import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";

import ContainerRoute from "../../components/routing/container-route";
import { OrganizationDetail } from "./detail";
import { OrganizationList } from "./list";

export default ({ responsiveStyles = {} }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <ContainerRoute
        exact={true}
        path={path}
        component={OrganizationList}
        responsiveStyles={responsiveStyles}
      ></ContainerRoute>
      <ContainerRoute
        exact={true}
        path={`${path}/:code`}
        component={OrganizationDetail}
        responsiveStyles={responsiveStyles}
      ></ContainerRoute>
    </Switch>
  );
};
